import script from "./DepositView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DepositView.vue?vue&type=script&lang=ts&setup=true"

import "./DepositView.vue?vue&type=style&index=0&id=36d11d56&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d11d56"]])

export default __exports__